import * as basketAPI from "../../api/basket";
import * as wishlistsAPI from "../../api/wishlists";
import { IProductAPIURL } from "../../models/nominals";

export const addProductToBasket = async (
    productURL: IProductAPIURL,
    qty?: number,
): Promise<void> => {
    // TODO(i18n): This is a developer-facing log message and does not need translation
    console.info(`[Configurator] Adding ${productURL} to basket`);
    await basketAPI.addProduct(productURL, qty);
};

export const addProductToWishList = async (
    wishListCode: string,
    productURL: IProductAPIURL,
): Promise<void> => {
    // TODO(i18n): This is a developer-facing log message and does not need translation
    console.info(`[Configurator] Adding ${productURL} to ${wishListCode}`);
    await wishlistsAPI.addLine(wishListCode, productURL);
};
